import { CalculatorConfig } from '@/types/calculator';

// Degree Length Calculator Configuration
export const DEGREE_LENGTH_CALCULATOR_CONFIG: CalculatorConfig = {
  id: 'degree-length-calculator',
  name: 'Degree Length Calculator',
  description:
    'Find the best route to your degree based on your goals and availability',
  title: 'Degree Length Calculator',
  subhed:
    'Explore our recommended degree timelines to learn what works best with your schedule.',
  formTitle: 'Start by entering your education details below',
  ctaText: 'Discover My Path',
  maxColumns: 3,
  fields: [
    {
      key: 'degree-type',
      type: 'select',
      label: 'Degree Type',
      placeholder: 'Select a degree',
      options: [
        { id: 1, name: 'Associate Degree (60 credits) ', slug: 'associates' },
        { id: 2, name: 'Bachelor Degree (120 credits)', slug: 'bachelors' },
        { id: 3, name: 'Master Degree (36 credits)', slug: 'masters' },
        { id: 4, name: 'Doctoral Degree (60 credits)', slug: 'doctorate' },
      ],
      required: true,
      validation: (value) => !!value || 'Please select a degree',
    },
    {
      key: 'academicInfo',
      type: 'text',
      label: 'Academic Information',
    },
    {
      key: 'creditsCompleted',
      type: 'number',
      label: 'Credits Completed',
      placeholder: 'Enter credits completed',
      required: false,
      validation: (value) =>
        (typeof value === 'number' && value >= 0) ||
        'Credits completed must be 0 or greater',
    },
    {
      key: 'totalCreditsRequired',
      type: 'number',
      label: 'Total Credits Required',
      placeholder: 'Enter total credits required',
      required: true,
      validation: (value) =>
        (typeof value === 'number' && value > 0) ||
        'Total credits must be greater than 0',
    },
    {
      key: 'personalCommitments',
      type: 'text',
      label: 'Personal Commitments',
    },
    {
      key: 'workCommitment',
      type: 'select',
      label: 'Work Commitment',
      placeholder: 'Select work commitment',
      required: true,
      options: [
        { id: 2, name: 'Part-Time (20-30 hrs/week)', slug: 'part-time' },
        { id: 3, name: 'Full-Time (40+ hrs/week)', slug: 'full-time' },
      ],
      validation: (value) => !!value || 'Please select your work commitment',
    },
    {
      key: 'urgency',
      type: 'select',
      label: 'Urgency',
      placeholder: 'Select urgency level',
      required: true,
      options: [
        {
          id: 1,
          name: 'Low',
          slug: 'low',
        },
        {
          id: 2,
          name: 'Medium',
          slug: 'medium',
        },
        {
          id: 3,
          name: 'High',
          slug: 'high',
        },
      ],
      validation: (value) => !!value || 'Please select your urgency level ',
    },
  ],
  tracking: {
    formatSubtype: 'program-length-entry',
    location: 'program-length',
    position: 'program-length',
    formName: 'program-length-calculator',
    formType: 'program-length',
    name: 'program-length-v1',
    cardformatSubtype: 'program-length-card',
  },
  defaultValues: {
    degree: '',
    creditsCompleted: null,
    totalCreditsRequired: null,
    maxClassesPerSemester: null,
    workCommitment: '',
    familyCommitments: '',
  },
  useDynamicDropdowns: true,
};
